import { Component, Input } from '@angular/core';
import { Uni30Trasferimento } from 'src/app/modules/shared/models/policy.model';

@Component({
  selector: 'app-policy-trasferimenti',
  templateUrl: './policy-trasferimenti.component.html',
  styleUrl: './policy-trasferimenti.component.scss'
})
export class PolicyTrasferimentiComponent {
  @Input() trasferimentiInIngresso: Uni30Trasferimento[];
  @Input() trasferimentiTfr: Uni30Trasferimento[];
  @Input() trasferimentiTecnici: Uni30Trasferimento[];


    ngOnInit(): void {

    }
}
